import React, { FunctionComponent } from 'react';
import { components } from 'react-select';

import { $MultiValueLabel } from './MultiValueLabel.styles';

const MultiValueLabel: FunctionComponent<React.PropsWithChildren<any>> = (
  props,
) => {
  return (
    <$MultiValueLabel title={props.data.label}>
      <components.MultiValueLabel {...props}>
        {props.children}
      </components.MultiValueLabel>
    </$MultiValueLabel>
  );
};

export default MultiValueLabel;
